import IconWarningFill from 'assets/Icons/Check/IconWarningFill';
import MobileBasicButton from 'components/Buttons/MobileBasicButton';
//import { MobileSelectButton } from 'components/Buttons/MobileSelectButton';
import { preciousChildPaths } from 'constants/path';
// import { BrowserRouter as Router, Route, useLocation, useBeforeUnload } from 'react-router-dom';
import { useLocation, useBeforeUnload } from 'react-router-dom';
import _ from 'lodash';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { BackgroundColor } from 'styles/Global/colorSemantic';
import { Radius } from 'styles/Global/objectStyles';
import { Body4SemiBold, Caption1Regular, Caption1SemiBold, Title2SemiBold } from 'styles/Global/typography';
import { VoucherCodeType } from 'utils/statusCode';
import { WarningItem } from './Components/WarningItem';
import { ProcessBox } from './Components/ProcessBox';

interface ProcessContents {
    key: string;
    title: string;
    subTitle: string;
    notice?: React.ReactNode;
}

const processContentsList: ProcessContents[] = [
    {
        key: 'prepare-test',
        title: '검사 준비하기',
        subTitle: '검사 진행을 위해 자녀와 주양육자의 정보를 입력해주세요.',
    },
    {
        key: 'conduct-test',
        title: '검사 진행하기',
        subTitle: '지정된 모든 검사를 진행하고 완료해보세요. 검사는 약 1시간 소요됩니다.',
    },
    {
        key: 'request-counseling',
        title: '상담 요청하기',
        subTitle: '상담 희망 날짜를 선택하고 요청해보세요. 상담사와 조율하여 지정된 상담일시를 전달드려요.',
    },
    {
        key: 'check-results',
        title: '검사 결과지 확인하기',
        subTitle: '검사를 모두 완료하고 상담을 요청하면, 결과지를 미리 확인할 수 있어요.',
        notice: (
            <div>
                <Caption1Regular>검사 설정을 위해 결과지에 </Caption1Regular>
                <Caption1SemiBold>'생년월일'</Caption1SemiBold>
                <Caption1Regular>과 </Caption1Regular>
                <Caption1SemiBold>'만 나이'</Caption1SemiBold>
                <Caption1Regular>는 입력한 정보와 다르게 표시될 수 있습니다. 이는 </Caption1Regular>
                <Caption1SemiBold>검사 결과와 상담에 문제가 되지 않으므로 참고 바랍니다.</Caption1SemiBold>
            </div>
        ),
    },
    {
        key: 'expert-counseling',
        title: '전문가와 상담하기',
        subTitle: '상담일시에 20분 동안 전화로 전문 상담사와 이야기를 나눠보세요. ',
    },
];

const processAIServiceList: ProcessContents[] = [
    {
        key: 'ai-prepare-test',
        title: '검사 준비하기',
        subTitle: '검사 진행을 위해 자녀와 주양육자의 정보를 입력해주세요.',
    },
    {
        key: 'ai-conduct-test',
        title: '검사 진행하기',
        subTitle: '지정된 모든 검사를 진행하고 완료해보세요. 검사는 약 1시간 소요됩니다.',
    },
    {
        key: 'ai-view-results',
        title: '검사 결과보기',
        subTitle: '모든 검사를 완료하고, 검사 결과를 받아보세요.',
        notice: (
            <div>
                <Caption1Regular>검사 설정을 위해 결과지에 </Caption1Regular>
                <Caption1SemiBold>'생년월일'</Caption1SemiBold>
                <Caption1Regular>과 </Caption1Regular>
                <Caption1SemiBold>'만 나이'</Caption1SemiBold>
                <Caption1Regular>는 입력한 정보와 다르게 표시될 수 있습니다. 이는 </Caption1Regular>
                <Caption1SemiBold>검사 결과와 상담에 문제가 되지 않으므로 참고 바랍니다.</Caption1SemiBold>
            </div>
        ),
    },
];

const AgreementPage = () => {
    const navigate = useNavigate();
    const { state } = useLocation();
    const [isAgree, setIsAgree] = useState(false);
    const [voucherType, setVoucherType] = useState(VoucherCodeType.MINDUPAI);
    const [processList, setProcessList] = useState<ProcessContents[]>([]);

    useEffect(() => {
        const newVoucherType = state?.data?.voucher?.type ?? VoucherCodeType.MINDUPAI;

        setVoucherType(newVoucherType);
        setProcessList(newVoucherType === VoucherCodeType.MINDUPAI ? processAIServiceList : processContentsList);
    }, []);

    useBeforeUnload((event) => {
        localStorage.clear();
    });

    const isMindUpAI = voucherType === VoucherCodeType.MINDUPAI;

    const goToNextPage = (isStart?: boolean) => {
        setIsAgree(true);
        localStorage.setItem('isAgree', JSON.stringify(true));

        if (isStart) {
            navigate(preciousChildPaths.childInfo, { replace: false, state: { data: state?.data } });
        } else {
            navigate(preciousChildPaths.detailLegal, { replace: false, state: { isAiType: isMindUpAI } });
        }
    };

    return (
        <Layout>
            <TitleContainer>
                <Title2SemiBold>{isMindUpAI ? 'AI 종합 심리검사는' : '상담검사 서비스는'}</Title2SemiBold>
                <Title2SemiBold>이렇게 진행될 예정이예요!</Title2SemiBold>
            </TitleContainer>
            <WarningContainer>
                <IconWarningFill />
                <WarningDescWrapper>
                    <Body4SemiBold>진행 주의사항</Body4SemiBold>
                    <WarningItem text='자녀와 주양육자가 함께 있을 때 진행해주세요.' isImportant />
                    <WarningItem text='검사 중에 선택한 응답은 자동 저장되지 않으므로, 시작한 검사는 끝까지 진행 후 완료해주세요.' />
                </WarningDescWrapper>
            </WarningContainer>
            <ContentsContainer>
                <SectionContainer>
                    <ProcessListContainer>
                        {_.map(processList, (e, i) => (
                            <ProcessBox key={e.key} index={i} title={e.title} subTitle={e.subTitle} notice={e.notice} />
                        ))}
                        {voucherType === VoucherCodeType.MINDUPAI && (
                            <ProcessBox key='ai-analysis' index={3} title='AI 맞춤 분석' secondTitle='✨ 확인하기' subTitle='검사 결과를 바탕으로 AI가 분석해주는 결과를 확인할 수 있어요.' />
                        )}
                    </ProcessListContainer>
                </SectionContainer>
                {/* <SectionContainer>
                    <AgreementSectionTitleContainer>
                        <Body5Medium>이용약관 동의</Body5Medium>
                        <Caption1Regular $color={TextColor.color_text_light}>원활한 검사 진행을 위해 이용약관에 동의해주세요.</Caption1Regular>
                    </AgreementSectionTitleContainer>
                    <MobileSelectButton
                        $selected={isAgree}
                        $onClick={() => {
                            goToNextPage();
                        }}
                        $containerClick={() => setIsAgree(!isAgree)}
                        $title='개인정보 수집 및 이용 동의'
                        $subTitle='(필수)'
                    />
                </SectionContainer> */}
            </ContentsContainer>
            <MobileBasicButton
                onClick={() => {
                    goToNextPage(true);
                }}
                $type='fill'
                $gap='4px'
                disabled={false}
            >
                {/* 동의하고 시작하기 */}
                시작하기
            </MobileBasicButton>
        </Layout>
    );
};

export default AgreementPage;

export const FontStyleType = {
    normal: 'normal',
    bold: 'bold',
} as const;

const Layout = styled.section`
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 0px 16px;
    gap: 32px;
`;

const TitleContainer = styled.div`
    display: flex;
    flex-direction: column;
`;

const ContentsContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 36px;
`;

const SectionContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

// const AgreementSectionTitleContainer = styled.div`
//     display: flex;
//     flex-direction: column;
//     gap: 4px;
// `;

const ProcessListContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

// const TitleAndWarningContainer = styled.div`
//     display: flex;
//     flex-direction: column;
//     width: 100%;
//     gap: 20px;
// `;

const WarningContainer = styled.div`
    display: flex;
    width: 100%;
    gap: 4px;
    padding: 12px 16px 14px 12px;
    background-color: ${BackgroundColor.color_background_warning};
    border-radius: ${Radius.radius_8};
`;

const WarningDescWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    padding-top: 1px;
`;
